import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty } from "lodash";
import { toast } from "wc-toast";
import moment from "moment";
const AddOffer = ({ onClose, object, type, getData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      category: "Deposit",
    },
  });

  const [image, setImage] = useState("");
  const uploadImage = async () => {
    let form = new FormData();
    form.append("BannerFile", image);
    const { status, data } = await apiPost(apiPath.uploadBanner, form);
    if (status == 200) {
      return data?.path;
    } else {
      return false;
    }
  };
  const onSubmit = async (body) => {
    let imageCheck = "";
    if (isImageInState()) {
      imageCheck = await uploadImage();
    } else {
      imageCheck = image;
    }
    if (isEmpty(imageCheck)) {
      toast.error("Please select image");
    } else {
      const { status, data: response_users } = await apiPost(apiPath.addOffer, {
        ...body,
        offerImage: imageCheck,
        id: !isEmpty(object) ? object?._id : "",
      });
      if (status == 200) {
        if (response_users.success) {
          onClose();
          getData();
        }
      }
    }
  };
  useEffect(() => {
    if (!isEmpty(object)) {
      setImage(object?.offerImage);
      setValue("category", object?.category);
      setValue(
        "offerStartDateTime",
        moment(object?.offerStartDateTime).format("YYYY-MM-DD")
      );
      setValue(
        "offerEndDateTime",
        moment(object?.offerEndDateTime).format("YYYY-MM-DD")
      );
      setValue("displayOrder", object?.displayOrder);
      setValue("title", object?.title);
      setValue("bonusCode", object?.bonusCode);
      setValue("bonusExpireinDays", object?.bonusExpireinDays);
      setValue("requiredTurnover", object?.requiredTurnover);
      setValue("offerOn", object?.offerOn);
      setValue("maxUser", object?.maxUser);
      setValue("offerBudget", object?.offerBudget);
      setValue("offerType", object?.offerType);
      setValue("percentageValue", object?.percentageValue);
      setValue("fixedValue", object?.fixedValue);
      setValue("minimumDeposite", object?.minimumDeposite);
      setValue("maxBounusValueUpTo", object?.maxBounusValueUpTo);
      setValue("depositeVaritationMin", object?.depositeVaritationMin);
      setValue("depositeVaritationMax", object?.depositeVaritationMax);
      setValue("maximumDeposite", object?.maximumDeposite);
      setValue(
        "depositeVaritationPercentage",
        object?.depositeVaritationPercentage
      );
      setValue("description", object?.description);
    }
  }, [type, object]);

  const isImageInState = () => {
    return image instanceof File && image.type.startsWith("image/");
  };
  const cat = [
    "Deposit",
    "Welcome Offer",
    "Slots",
    "Casino",
    "Sports",
    "Fishing",
    "Card Game",
    "ESports",
    "Lottery",
    "P2P",
    "Table",
    "Arcade",
    "Cock Fighting",
    "Rain",
    "Crash",
    "Tips",
    "Others",
  ];

  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-status">Add Offer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              {" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Category
                    </span>
                    <Form.Select
                      style={{ height: "36px" }}
                      disabled={type == "show"}
                      className={errors.category ? " is-invalid mt-1" : "mt-1"}
                      {...register("category", {
                        required: "Please select category",
                      })}
                    >
                      {" "}
                      <option value={""}>Select Category</option>{" "}
                      {cat?.map((res) => {
                        return <option value={res}>{res}</option>;
                      })}
                    </Form.Select>
                    {errors.offerOn && errors.offerOn.message && (
                      <label className="invalid-feedback text-left">
                        {errors.offerOn.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Offer Start DateTime *
                    </span>
                    <Form.Control
                      type="date"
                      disabled={type == "show"}
                      className={
                        errors.offerStartDateTime ? " is-invalid mt-1" : "mt-1"
                      }
                      max={new Date().toISOString().split("T")[0]}
                      {...register("offerStartDateTime", {
                        required: "Please enter Offer Start DateTime",
                      })}
                    />
                    {errors.offerStartDateTime &&
                      errors.offerStartDateTime.message && (
                        <label className="invalid-feedback text-left">
                          {errors.offerStartDateTime.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>{" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Offer End DateTime *
                    </span>
                    <Form.Control
                      type="date"
                      className={
                        errors.offerEndDateTime ? " is-invalid mt-1" : "mt-1"
                      }
                      min={
                        !isEmpty(watch("offerStartDateTime"))
                          ? new Date(watch("offerStartDateTime"))
                              .toISOString()
                              .split("T")[0]
                          : new Date()
                      }
                      disabled={
                        !isEmpty(watch("offerStartDateTime")) ? false : true
                      }
                      // max={new Date().toISOString().split("T")[0]}
                      {...register("offerEndDateTime", {
                        required: "Please enter Offer End DateTime",
                      })}
                    />
                    {errors.offerEndDateTime &&
                      errors.offerEndDateTime.message && (
                        <label className="invalid-feedback text-left">
                          {errors.offerEndDateTime.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>{" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Display Order *
                    </span>
                    <Form.Control
                      type="number"
                      disabled={type == "show"}
                      placeholder="Display Order"
                      className={
                        errors.displayOrder ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("displayOrder", {
                        required: "Please enter Display Order",
                      })}
                    />
                    {errors.displayOrder && errors.displayOrder.message && (
                      <label className="invalid-feedback text-left">
                        {errors.displayOrder.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>{" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Title *
                    </span>
                    <Form.Control
                      type="text"
                      disabled={type == "show"}
                      placeholder="Title"
                      className={errors.title ? " is-invalid mt-1" : "mt-1"}
                      {...register("title", {
                        required: "Please enter Title",
                      })}
                    />
                    {errors.title && errors.title.message && (
                      <label className="invalid-feedback text-left">
                        {errors.title.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Bonus Code *
                    </span>
                    <Form.Control
                      type="text"
                      disabled={type == "show"}
                      placeholder="Bonus Code"
                      className={errors.bonusCode ? " is-invalid mt-1" : "mt-1"}
                      {...register("bonusCode", {
                        required: "Please enter Bonus Code",
                      })}
                    />
                    {errors.bonusCode && errors.bonusCode.message && (
                      <label className="invalid-feedback text-left">
                        {errors.bonusCode.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Bonus Expire in Days *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Bonus Expire in Days"
                      className={
                        errors.bonusExpireinDays ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("bonusExpireinDays", {
                        required: "Please enter Bonus Expire in Days",
                      })}
                    />
                    {errors.bonusExpireinDays &&
                      errors.bonusExpireinDays.message && (
                        <label className="invalid-feedback text-left">
                          {errors.bonusExpireinDays.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Required Turnover *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Required Turnover"
                      className={
                        errors.requiredTurnover ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("requiredTurnover", {
                        required: "Please enter Required Turnover",
                      })}
                    />
                    {errors.requiredTurnover &&
                      errors.requiredTurnover.message && (
                        <label className="invalid-feedback text-left">
                          {errors.requiredTurnover.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Offer On *
                    </span>
                    <Form.Select
                      disabled={type == "show"}
                      style={{ height: "36px" }}
                      className={errors.offerOn ? " is-invalid mt-1" : "mt-1"}
                      {...register("offerOn", {
                        required: "Please select offer on",
                      })}
                    >
                      {" "}
                      <option value={""}>Select Deposite Type</option>{" "}
                      <option value={"OnFirstDeposit"}>OnFirstDeposit</option>{" "}
                      <option value={"OnDeposit"}>OnDeposit</option>{" "}
                      <option value={"OnRegister"}>OnRegister</option>{" "}
                      <option value={"OnSecondDeposit"}>OnSecondDeposit</option>{" "}
                      <option value={"OnThirdDeposit"}>OnThirdDeposit</option>{" "}
                      <option value={"OnEveryDeposit"}>OnEveryDeposit</option>{" "}
                      <option value={"SpecialOffer"}>SpecialOffer</option>
                    </Form.Select>
                    {errors.offerOn && errors.offerOn.message && (
                      <label className="invalid-feedback text-left">
                        {errors.offerOn.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Max User *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Max User"
                      className={errors.maxUser ? " is-invalid mt-1" : "mt-1"}
                      {...register("maxUser", {
                        required: "Please enter Max User",
                      })}
                    />
                    {errors.maxUser && errors.maxUser.message && (
                      <label className="invalid-feedback text-left">
                        {errors.maxUser.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Offer Budget *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Offer Budget"
                      className={
                        errors.offerBudget ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("offerBudget", {
                        required: "Please enter Offer Budget",
                      })}
                    />
                    {errors.offerBudget && errors.offerBudget.message && (
                      <label className="invalid-feedback text-left">
                        {errors.offerBudget.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Offer Type *
                    </span>
                    <Form.Select
                      disabled={type == "show"}
                      style={{ height: "36px" }}
                      className={errors.offerType ? " is-invalid mt-1" : "mt-1"}
                      {...register("offerType", {
                        required: "Please select offer type",
                      })}
                    >
                      {" "}
                      <option value={""}>Select Offer Type</option>
                      <option value={"Fixed"}>Fixed</option>{" "}
                      <option value={"Percentage"}>Percentage</option>{" "}
                    </Form.Select>
                    {errors.offerType && errors.offerType.message && (
                      <label className="invalid-feedback text-left">
                        {errors.offerType.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              {watch("offerType") == "Percentage" && (
                <Col sm={12} lg={4} md={4} className="mb-2">
                  <Form.Group className="row">
                    <div>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Percentage Value *
                      </span>
                      <Form.Control
                        disabled={type == "show"}
                        type="number"
                        placeholder="Percentage Value"
                        className={
                          errors.percentageValue ? " is-invalid mt-1" : "mt-1"
                        }
                        {...register("percentageValue", {
                          required: "Please enter Percentage Value",
                        })}
                      />
                      {errors.percentageValue &&
                        errors.percentageValue.message && (
                          <label className="invalid-feedback text-left">
                            {errors.percentageValue.message}
                          </label>
                        )}
                    </div>
                  </Form.Group>
                </Col>
              )}
              {watch("offerType") == "Fixed" && (
                <Col sm={12} lg={4} md={4} className="mb-2">
                  <Form.Group className="row">
                    <div>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Fixed Value *
                      </span>
                      <Form.Control
                        disabled={type == "show"}
                        type="number"
                        placeholder="Fixed Value"
                        className={
                          errors.fixedValue ? " is-invalid mt-1" : "mt-1"
                        }
                        {...register("fixedValue", {
                          required: "Please enter Fixed Value",
                        })}
                      />
                      {errors.fixedValue && errors.fixedValue.message && (
                        <label className="invalid-feedback text-left">
                          {errors.fixedValue.message}
                        </label>
                      )}
                    </div>
                  </Form.Group>
                </Col>
              )}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Minimum Deposite *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Minimum Deposite"
                      className={
                        errors.minimumDeposite ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("minimumDeposite", {
                        required: "Please enter Minimum Deposite",
                      })}
                    />
                    {errors.minimumDeposite &&
                      errors.minimumDeposite.message && (
                        <label className="invalid-feedback text-left">
                          {errors.minimumDeposite.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Maximum Deposite *
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Maximum Deposite"
                      className={
                        errors.maximumDeposite ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("maximumDeposite", {
                        required: {
                          value: true,
                          message: "Please enter Maximum Deposite",
                        },
                        // validate: (value) => {
                        //   if (watch("MinimumDeposite") > value) {
                        //     return "MaxDeposit should be greater than min deposit";
                        //   }
                        // },
                      })}
                    />
                    {errors.maximumDeposite &&
                      errors.maximumDeposite.message && (
                        <label className="invalid-feedback text-left">
                          {errors.maximumDeposite.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>
              {watch("offerType") == "Percentage" && (
                <Col sm={12} lg={4} md={4} className="mb-2">
                  <Form.Group className="row">
                    <div>
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "500",
                        }}
                      >
                        Max Bounus Value UpTo *
                      </span>
                      <Form.Control
                        disabled={type == "show"}
                        type="number"
                        placeholder="Max Bounus Value UpTo"
                        className={
                          errors.maxBounusValueUpTo
                            ? " is-invalid mt-1"
                            : "mt-1"
                        }
                        {...register("maxBounusValueUpTo", {
                          required: "Please enter Max Bounus Value UpTo",
                        })}
                      />
                      {errors.maxBounusValueUpTo &&
                        errors.maxBounusValueUpTo.message && (
                          <label className="invalid-feedback text-left">
                            {errors.maxBounusValueUpTo.message}
                          </label>
                        )}
                    </div>
                  </Form.Group>
                </Col>
              )}
            </Row>{" "}
            {/* <h5 style={{ margin: "10px 0", fontWeight: "500" }}>
              Deposite Varitation
            </h5>
            <Row>
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Min"
                      className={
                        errors.depositeVaritationMin
                          ? " is-invalid mt-1"
                          : "mt-1"
                      }
                      {...register("depositeVaritationMin", {
                        required: "Please enter min",
                      })}
                    />
                    {errors.depositeVaritationMin &&
                      errors.depositeVaritationMin.message && (
                        <label className="invalid-feedback text-left">
                          {errors.depositeVaritationMin.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>{" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Max"
                      className={
                        errors.depositeVaritationMax
                          ? " is-invalid mt-1"
                          : "mt-1"
                      }
                      {...register("depositeVaritationMax", {
                        required: "Please enter max",
                      })}
                    />
                    {errors.depositeVaritationMax &&
                      errors.depositeVaritationMax.message && (
                        <label className="invalid-feedback text-left">
                          {errors.depositeVaritationMax.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>{" "}
              <Col sm={12} lg={4} md={4} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <Form.Control
                      disabled={type == "show"}
                      type="number"
                      placeholder="Percentage"
                      className={
                        errors.depositeVaritationPercentage
                          ? " is-invalid mt-1"
                          : "mt-1"
                      }
                      {...register("depositeVaritationPercentage", {
                        required: "Please enter percentage",
                      })}
                    />
                    {errors.depositeVaritationPercentage &&
                      errors.depositeVaritationPercentage.message && (
                        <label className="invalid-feedback text-left">
                          {errors.depositeVaritationPercentage.message}
                        </label>
                      )}
                  </div>
                </Form.Group>
              </Col>{" "}
            </Row> */}
            <Row>
              <Col sm={12} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Description
                    </span>
                    <Form.Control
                      disabled={type == "show"}
                      style={{ height: "80px" }}
                      as="textarea"
                      rows={3}
                      placeholder="Description"
                      className={
                        errors.description ? " is-invalid mt-1" : "mt-1"
                      }
                      {...register("description")}
                    />
                    {errors.description && errors.description.message && (
                      <label className="invalid-feedback text-left">
                        {errors.description.message}
                      </label>
                    )}
                  </div>
                </Form.Group>
              </Col>
              <Col sm={12} lg={6} md={6} className="mb-2">
                <Form.Group className="row">
                  <div>
                    <input
                      onChange={(e) => {
                        setImage(e.target.files[0]);
                      }}
                      type="file"
                      class="fileInput"
                      accept="image/webp, image/png, image/jiffy, image/jpeg, image/jpg"
                    />
                  </div>
                  {image !== "" && (
                    <Col sm={12} className="mt-2">
                      <img
                        src={
                          isImageInState()
                            ? URL?.createObjectURL(image)
                            : !isEmpty(image)
                            ? `${process.env.REACT_APP_API_BASE_URL}${image}`
                            : ""
                        }
                      />
                    </Col>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end align-items-center mt-1">
              {type != "show" && (
                <Button
                  type="submit"
                  className="green-btn"
                  style={{ color: "black" }}
                >
                  Submit
                </Button>
              )}
              <Button
                type="button"
                onClick={() => onClose()}
                className="theme_light_btn btn btn-primary"
                style={{ marginLeft: "10px" }}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddOffer;
